var _rect, _rect2, _rect3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDasimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.41264,
    y: 1.34367,
    width: 13.0394,
    height: 13.0394,
    rx: 6.51968,
    fill: "white",
    stroke: "#271E4A",
    strokeWidth: 2.61251
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.41264,
    y: 22.5854,
    width: 13.0394,
    height: 13.0394,
    rx: 6.51968,
    fill: "white",
    stroke: "#271E4A",
    strokeWidth: 2.61251
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6545,
    y: 1.34367,
    width: 13.0394,
    height: 13.0394,
    rx: 6.51968,
    fill: "white",
    stroke: "#271E4A",
    strokeWidth: 2.61251
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.1742,
    cy: 29.1051,
    r: 6.51968,
    stroke: "#271E4A",
    strokeWidth: 2.61251
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDasimage);
export default __webpack_public_path__ + "static/media/dasimage.f099c80549753cc92a1a7f2c9572fbe5.svg";
export { ForwardRef as ReactComponent };